import { useEffect, useRef } from 'react';

import Viewer from 'viewerjs';

import 'viewerjs/dist/viewer.css';
import { ImageViewerProps } from '../model';

const ImageViewer: React.FC<ImageViewerProps> = ({ src, srcs, initialIndex = 0, trigger, onClose }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const viewerRef = useRef<Viewer | null>(null);

  useEffect(() => {
    if (containerRef.current && trigger) {
      viewerRef.current = new Viewer(containerRef.current, {
        inline: false,
        navbar: true,
        movable: true,
        title: false,
        initialViewIndex: initialIndex,
        toolbar: {
          zoomIn: { show: true, size: 'large' },
          zoomOut: { show: true, size: 'large' },
          oneToOne: 0,
          reset: { show: true, size: 'large' },
          prev: { show: true, size: 'large' },
          play: 0,
          next: { show: true, size: 'large' },
          rotateLeft: { show: true, size: 'large' },
          rotateRight: { show: true, size: 'large' },
          flipHorizontal: 0,
          flipVertical: 0,
        },
        hidden: () => {
          onClose?.();
        },
      });

      const isDark = document.documentElement.classList.contains('dark');
      if (isDark) {
        const viewerContainer = document.querySelector('.viewer-container');
        if (viewerContainer) {
          viewerContainer.classList.add('dark');
        }
      }

      viewerRef.current.show();
    }

    return () => {
      viewerRef.current?.destroy();
    };
  }, [trigger, onClose]);

  return (
    <div ref={containerRef} style={{ display: 'none' }}>
      {srcs && srcs.length > 0 ? (
        srcs.map((s, index) => <img key={index} src={s} alt={`preview ${index}`} />)
      ) : (
        src && <img src={src} alt="preview" />
      )}
    </div>
  );
};

export default ImageViewer;
